export const RESOLUTION = {
  SMALL: 576,
  MEDIUM: 768,
  LARGE: 998,
  EXTRA_LARGE: 1200,
};

export const isMobile = window.innerWidth <= RESOLUTION.LARGE;
export const { API_URL } = process.env;
export const SESSION_TOKEN_NAME = 'vroom_vroom_marketplace_session';
export const COUNT_OF_COLUMNS = isMobile ? 1 : 7;

export const EXAM_CENTERS_CONFIG = {
  'La Poste': {
    name: 'la_poste',
    url: 'laPoste',
    session: 'la_poste_exam_sessions',
    siteSession: 'exam_sessions',
  },
  Codengo: {
    name: 'codengo',
    url: 'Codengo',
    session: 'codengo_session',
    siteSession: 'exam_sessions',
    link: {
      href:
        'https://codengo.bureauveritas.fr/portal/public/referentiel/cgv.pdf',
      text: 'Voir conditions générales de vente.',
    },
  },
  Dekra: {
    name: 'dekra',
    url: 'Dekra',
  },
  SGS: {
    name: 'sgs',
    url: 'sgs',
  },
};

export const SLOTS_API_URLS = {
  codengo: process.env.CODENGO_SLOTS_API_URL,
  la_poste: process.env.LA_POSTE_SLOTS_API_URL,
  dekra: process.env.DEKRA_SLOTS_API_URL,
  sgs: process.env.SGS_SLOTS_API_URL,
};

export const Z_INDEXES = {
  HEADER: 0,
  OVERLAY: 10000,
};

export const CONTACTS = {
  tel: '01\xa085\xa008\xa047\xa051',
  email: 'contact@vroomvroom.fr',
};

export const PARIS_CENTER = { latitude: 48.853398, longitude: 2.348775 };

export const REVIEW_MIN_DATE_ISO = '2010-01-01T00:00:00.000Z';

export const AUTOCOMPLETE_SETTINGS = {
  hint: false,
  debug: true,
  cssClasses: {
    prefix: 'ad-example',
  },
};

export const SUBMIT_RESULT_MESSAGES = {
  success: 'Merci ! Vous allez être recontacté(e) sous peu',
  error: 'Une erreur est survenue, veuillez réessayer',
};
